<template>
  <b-modal
    :id="id"
    size="lg"
    :title="clone ? 'Clone Minor Version' : 'Create New Minor Version'"
    lazy
    hide-footer>
    <b-form
      inline
      @submit="onSubmit"
      @reset="onReset">
      <b-form-select
        id="majorVersions"
        v-model="selectedMajorConfig"
        class="mx-2"
        :options="majorConfigOptions"
        @change="onSelectMajor" />
      <div v-if="clone">
        <b-form-select
          id="existingVersions"
          v-model="selectedConfig"
          class="mx-2"
          :options="minorConfigOptions"
          required />
      </div>
      <label
        class="sr-only"
        for="newConfigValue">
        Name
      </label>
      <b-form-input
        id="newConfigValue"
        ref="newConfigValue"
        v-model="newConfig"
        type="text"
        :disabled="!selectedMajorConfig"
        :placeholder="minorConfigPlaceHolder()"
        required />
      <div
        slot="modal-footer"
        class="mt-2 w-100">
        <b-btn
          type="submit"
          variant="primary"
          class="ml-2 float-right">
          {{ clone ? 'Clone' : 'Create' }}
        </b-btn>
        <b-btn
          type="reset"
          variant="secondary"
          class="float-right">
          Cancel
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>

  import { Config } from '@/services/api'

  export default {
    name: "NewMinorConfigModal",
    props: {
      id: {
        type: String,
        required: true,
      },
      platformId: {
        type: Number,
        required: false,
        default: null,
      },
      clone: {
        type: Boolean,
        default: false,
      },
      configs: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        majorConfigOptions: [],
        minorConfigOptions: [],
        selectedMajorConfig: null,
        selectedConfig: null,
        newConfig: null,
      }
    },
    watch: {
      configs(newVal) {
        this.majorConfigOptions = newVal.map(c => {
          return {
            text: c.version,
            value: c.id,
          }
        })
        this.majorConfigOptions.unshift({text: '-- Select Major --', value: null})
      },
    },
    methods: {
      onReset() {
        this.selectedMajorConfig = null
        this.selectedConfig = null
        this.newConfig = null
        this.$root.$emit('bv::hide::modal', this.id)
      },
      async onSubmit(evt) {
        evt.preventDefault()
        let minorID
        if (this.clone) {
          minorID = await Config.cloneMinor(this.platformId, this.selectedMajorConfig, this.selectedConfig, this.newConfig)
        } else {
          minorID = await Config.createMinor(this.platformId, this.selectedMajorConfig, this.newConfig)
        }
        this.$router.push({ path: '/', query: { platformId: this.platformId.toString(), majorId: this.selectedMajorConfig.toString(), minorId: minorID.toString() } })
        this.onReset()
      },
      onSelectMajor(majorVersionID) {
        this.minorConfigOptions = this.configs.find(v => v.id === majorVersionID).minors.map(c => {
          return {
            text: c.version,
            value: c.version,
          }
        })
        this.selectedConfig = this.minorConfigOptions.map(r => r.value)[this.minorConfigOptions.length - 1]
      },
      minorConfigPlaceHolder() {
        const majorConfig = this.configs.find(c => c.id === this.selectedMajorConfig)
        return majorConfig ? (this.clone ? 'New Minor Version' : `${majorConfig.version}.0.1`) : null
      },
    },
  }
</script>

<style scoped>

</style>